module.exports = __webpack_public_path__ + "img/54.eaa3b2a6.jpg";